import { Link } from 'gatsby';
import React, { useState, useEffect, useRef } from 'react';
import { getGrowtime, alterName, convertPrice } from '../utils';
import data from '../data/data.json';

export default function ItemView({ item, price }) {
  const { name, type, description, rarity, recipe } = item;
  const [recipeOf, setRecipeOf] = useState([]);
  const currentIndex = useRef(0);

  const navigate = e => {
    if (e.isComposing || e.keyCode === 229) {
      return;
    }

    // Down arrow
    if (e.keyCode === 40 && recipeOf.length) {
      currentIndex.current = (currentIndex.current % recipeOf.length) + 1;
      const selector = `#gatsby-focus-wrapper > main > div > div > ul > li:nth-child(${currentIndex.current}) > a`;

      let item = document.querySelector(selector);
      if (item) item.focus();
    }
    // Up arrow
    if (e.keyCode === 38 && recipeOf.length) {
      currentIndex.current -= 1;
      if (currentIndex.current <= 0) currentIndex.current = recipeOf.length;
      const selector = `#gatsby-focus-wrapper > main > div > div > ul > li:nth-child(${currentIndex.current}) > a`;

      let item = document.querySelector(selector);
      if (item) item.focus();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', navigate);

    return () => window.removeEventListener('keydown', navigate);
  });

  useEffect(() => {
    let res = [];

    data.forEach(item => {
      if (item.recipe?.length) {
        const firstRecipe = item.recipe[0].replace(' Seed', '');
        const secondRecipe = item.recipe[1].replace(' Seed', '');
        if (firstRecipe === name || secondRecipe === name) res.push(item);
      }
    });

    setRecipeOf(res);
  }, [setRecipeOf, name]);

  return (
    <div className="item-view">
      <h1 className="item-name">
        <img
          src={`/${alterName(name)}.png`}
          alt={name}
          width="32"
          height="32"
        />{' '}
        {name}
      </h1>
      <p className="item-description fade">{description}</p>
      <span className="item-type">
        <span className="fade">Type:</span>&nbsp;
        <Link to={`/type/${alterName(type, true)}`}>{type}</Link>
      </span>
      {rarity ? (
        <>
          <span className="item-rarity">
            <span className="fade">Rarity:</span>
            &nbsp;<Link to={`/rarity/${rarity}`}>{rarity}</Link>
          </span>
          <span className="item-growtime">
            <span className="fade">Growtime:</span> {getGrowtime(rarity)}
          </span>
        </>
      ) : (
        ''
      )}
      {price ? (
        <>
          <span className="item-price">
            <span className="fade">Price:</span>
            &nbsp;{convertPrice(price)}&nbsp;
            <button>edit</button>
          </span>
        </>
      ) : (
        ''
      )}
      {recipe?.length === 2 ? (
        <span className="recipe-box">
          <span className="fade">Recipe:</span>
          <Link to={`/${alterName(recipe[0], true)}`} className="item-recipe">
            <img
              src={`/${alterName(recipe[0])}.png`}
              alt={recipe[0].replace(' Seed', '')}
              width="32"
              height="32"
            />
            {recipe[0]}
          </Link>
          <Link to={`/${alterName(recipe[1], true)}`} className="item-recipe">
            <img
              src={`/${alterName(recipe[1])}.png`}
              alt={recipe[1].replace(' Seed', '')}
              width="32"
              height="32"
            />
            {recipe[1]}
          </Link>
        </span>
      ) : (
        ''
      )}
      {recipeOf.length ? (
        <div className="recipeOf">
          <h2 className="fade">
            Use <strong>{name}</strong> to splice{' '}
            {recipeOf.length > 2 ? `one of these items` : 'this item'}:
          </h2>
          <ul>
            {recipeOf.map((item, i) => (
              <li key={item.name}>
                <Link
                  className="recipeOf-item"
                  to={`/${alterName(item.name, true)}`}
                >
                  <img
                    src={`${alterName(item.name)}.png`}
                    alt={item.name}
                    width="32"
                    height="32"
                  />
                  <span className="recipeOf-name">{item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
